import React, { Fragment } from "react";
import { Flex } from "theme-ui";

interface Props {
  reverse?: boolean;
  image: JSX.Element;
  title: string;
  text: string;
  stats: {
    number: string | number | JSX.Element;
    stat: string;
  }[];
}

const CircleStatsSection = ({ title, text, reverse, stats, image }: Props) => {
  return (
    <Flex
      sx={{
        flexDirection: ["column", null, null, reverse ? "row-reverse" : "row"],
        justifyContent: ["center", null, null, "space-between"],
        alignItems: "center",
        maxWidth: 1178,
        width: [300, 375, null, "100%"],
        px: [0, null, null, 3],
        pb: [0, null, null, 4],
      }}
    >
      <Flex
        // data-sal={reverse ? "slide-left" : "slide-right"}
        // data-sal-delay="100"
        // data-sal-duration="800"
        // data-sal-easing="easeOutQuart"
        sx={{
          flexDirection: "column",
          alignItems: ["center", null, null, "flex-start"],
        }}
      >
        <h2
          sx={{
            variant: "text.h1HeaderRegular",
            pb: [4, null, null, 0],
          }}
        >
          {title}
        </h2>
        <div
          sx={{
            display: ["block", null, null, "none"],
          }}
        >
          {image}
        </div>
        <p
          sx={{
            display: ["none", null, null, "block"],
            variant: "text.bodyNew",
            maxWidth: 700,
            py: 21,
          }}
        >
          {text}
        </p>
        <Flex
          sx={{
            flexDirection: ["column", null, null, "row"],
            alignItems: ["center", null, null, "flex-start"],
            py: [3, null, null, "0px"],
          }}
        >
          {stats.map((stat, i: number) => (
            <Flex
              key={i}
              sx={{
                alignItems: "center",
                py: [2, null, null, 0],
              }}
            >
              <div>
                <h3
                  sx={{
                    variant: "text.h1InfoText",
                    textAlign: ["center", null, null, "left"],
                  }}
                >
                  {stat.number}
                </h3>
                <p
                  sx={{
                    variant: "text.bodyNew",
                    textAlign: ["center", null, null, "left"],
                  }}
                >
                  {stat.stat}
                </p>
              </div>
              {i < stats.length - 1 && (
                <div
                  sx={{
                    width: 1,
                    height: 75,
                    bg: "#000",
                    mx: 4,
                    display: ["none", null, null, "block"],
                  }}
                ></div>
              )}
            </Flex>
          ))}
        </Flex>
      </Flex>
      <div
        // data-sal={"zoom-in"}
        // data-sal-delay="100"
        // data-sal-duration="800"
        // data-sal-easing="easeOutQuart"
        sx={{
          display: ["none", null, null, "block"],
          px: 3,
        }}
      >
        {image}
      </div>
    </Flex>
  );
};

export default CircleStatsSection;
